angular.module('tf.controllers')

    .controller('SignupController', function ($scope, $rootScope, AuthService,Session, $state, $timeout, $stateParams,SessionStorageService,
                                            AuthAlertService, $cookies, NotificationService, $http, RecaptchaService) {

        var SIGNUP_SESSION_STORAGE_KEY = "tf_signup_session";
        $scope.credentials = SessionStorageService.getObject(SIGNUP_SESSION_STORAGE_KEY) || {};
        $scope.disableButton = false;
        $scope.requireSSO = false;
        $scope.referer = $stateParams.referer;
        $rootScope.$broadcast('working',false);


        $scope.signup = function (credentials) {
            $scope.disableButton = true;
            if($scope.requireSSO){
                window.location.href = '/sso?email=' + credentials.email;
                return;
            }
            if(!AuthService.validateCredentials(credentials)){
                $scope.disableButton = false;
                return;
            }
            var signupFunction = AuthService.signupMultiStep;
            switch ($state.current.name) {
                case 'signup.email':
                    AuthService.redirectAfterLogin($stateParams.tfref? 'login' : 'verify');
                    break;
                case 'signup.email-sep':
                    AuthService.redirectAfterLogin('signup.password-sep');
                    break;
                case 'signup.password-dep':
                    AuthService.redirectAfterLogin('verify');
                    break;
               case 'signup.account':
                    signupFunction = AuthService.userUpdate;
                    break;
            }
            $rootScope.$broadcast('working',true);
            RecaptchaService.execute('signup').then(function(token){
                credentials['g-recaptcha-response'] = token;
                signupFunction(credentials).then(function(res){
                    $rootScope.$broadcast('working',false);
                    SessionStorageService.removeItem(SIGNUP_SESSION_STORAGE_KEY);
                    $scope.disableButton = false;
                },function(err){
                    $scope.disableButton = false;
                    $rootScope.$broadcast('working',false);
                });
            });

        };

        if($scope.referer && $scope.referer.email){
            $scope.credentials.email = $scope.referer.email;
            $scope.credentials.confirmEmail = $scope.credentials.email;
            $scope.emailPreset = true;
        }
        $scope.$on("login-info", function(event, data){
            $scope.showAlert(data);
        });
        $scope.$on("login-error", function(event, data){
            $scope.showAlert(data);
        });
        $scope.$on("signup-error", function(event, data){
            $scope.showAlert(data);
        });
        $scope.showAlert = function(alert){
            $timeout(function(){alert.show();},1);
        };

        (function handleInit(){
            var emailFromCookie = $cookies.get('user_email');
            if(emailFromCookie && $state.params.tfref){
                $scope.credentials.email = emailFromCookie;
                $scope.credentials.confirmEmail = emailFromCookie;
                $scope.emailPreset = true;
            }
            RecaptchaService.renderV3('signup-recaptcha');
        })();
    })
;
